import * as React from 'react';
import { useContext } from 'react';
import Wrapper from '@components/Wrapper';
import Button from '@components/Button';
import closeBtnIcon from '@icons/closeBtnIcon';
import { GlobalStateContext } from '@context/context';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './style.module.scss';

const {
  infoBox,
  infoBox__button,
  infoBox__container,
  infoBox__buttonContainer,
  infoBox__main,
  infoBox__close,
} = styles;

const DealfrontAIBanner = () => {
  const { language } = useI18next();
  const { t } = useTranslation();
  const { setShowInfoBox } = useContext(GlobalStateContext);

  return (
    <div className={infoBox}>
      <Wrapper classes={infoBox__container}>
        <div className={infoBox__main}>
          <StaticImage
            placeholder="none"
            src="../../../images/icons/df-button-ai.png"
            alt="Dealfront AI campaign banner image"
          />
          <p>{t('dealfront_ai_banner_text')}</p>
        </div>
        <div className={infoBox__buttonContainer}>
          <Button
            href="/platform/features/ai-insights/"
            size="small"
            classes={infoBox__button}
          >
            {t('dealfront_ai_banner_link')}
          </Button>
        </div>
      </Wrapper>
      <div onClick={() => setShowInfoBox(false)} className={infoBox__close}>
        {closeBtnIcon}
      </div>
    </div>
  );
};

export default DealfrontAIBanner;
